<h1 mat-dialog-title>Recordar Contraseña</h1>
<div mat-dialog-content>
    <form [formGroup]="form">
        <div fxLayout="row wrap">
            <div class="p-10" fxFlex="100">
                <mat-form-field>
                    <input
                        matInput
                        placeholder="Correo electronico registrado *"
                        [formControl]="form.controls['email']"
                    />
                    <mat-hint
                        *ngIf="form.controls['email'].hasError('required') && form.controls['email'].touched"
                        class="text-danger font-14"
                        >Debe indicar el correo electronico registrado</mat-hint
                    >
                    <mat-hint
                        *ngIf="form.controls['email'].hasError('email') && form.controls['email'].touched"
                        class="text-danger font-14"
                        >Debe especificar un correo electronico válido</mat-hint
                    >
                </mat-form-field>
            </div>
        </div>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="onCancel()" tabindex="2">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onSend()" [disabled]="!form.valid || isSaving" tabindex="1">
        Recordar
    </button>
</div>
